import React, { Component } from "react";
import { Form, Input, Radio, Button, message, Upload, Icon } from "antd";
import NHFormItem from '../../common/NHFormItem';
import NHFetch from '../../../utils/NHFetch';
import NHUpload from '../../common/NHUpload';
import styles from "./Video.css";

@Form.create()
export default class CommonModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      splx: "1", //视频类型,默认选择外链
      spsm: "", //视频说明
      spmc: "", //视频标题
      spfjid: "", //视频附件id
      spdz: "", //视频地址
      slt: "", //视频的图片封面地址
      sltfjid: "", //封面附件id
      buttonLoading: false,
      radioValue: 1, //视频类型
      lj: "", //外部链接的值
    };
  }
  UNSAFE_componentWillMount() {
    if (this.props.formData.pkid == undefined) {
      //新增操作
      return;
    }
    this.setState({
      operate: "update",
    });
    console.log("修改操作", this.props.formData);

    const {
      spdz,
      spsm,
      spmc,
      spfjid,
      sltfjid,
      slt,
      splx,
    } = this.props.formData;

    let fjarr = splx == "1" ? [sltfjid] : [sltfjid, spfjid];
    let lj = splx == "1" ? spdz : "";
    // 保存附件状态

    //外部链接形式，没有spfjid
    console.log("fjarr", fjarr);
    NHFetch("front/zhxg-unauth/dynamic/save", "POST", fjarr).then((res) => {
      // console.log("保存附件状态成功");
      if (res && res.code == 200) {
        console.log("修改页面读取xpdz请求成功");
        this.setState({
          spdz,
          spsm,
          spmc,
          spfjid,
          sltfjid,
          splx,
          slt,
          lj,
        });
      }
    });
  }
  //处理点击确定
  handleSubmit = (e) => {
    console.log("点击确定");
    e.preventDefault();
    //对表单的数据进行规则校验，如必填等
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({
          buttonLoading: true,
        });

        console.log("values", values);
        const { spdz, slt } = this.state;
        values.spdz = spdz;
        values.slt = slt;
        if (this.props.formData.pkid) {
          //修改操作
          values.pkid = this.props.formData.pkid;
        }
        let url = this.props.formData.pkid ? `/fwwgl/video/update` : `/fwwgl/video/insert`;
        const info = this.state.operate == "update" ? "修改" : "新增"; //提示信息

        NHFetch(url, "POST", values)
          .then((res) => {
            this.setState({
              buttonLoading: false,
            });
            if (res && res.code === 200) {
              message.success(`视频${info}信息成功！`);
              this.props.onCancel();
            }
          })
          .catch((err) => {
            this.setState({
              buttonLoading: false,
            });
            message.error(err);
            this.props.onCancel();
          });
      }
    });
  };
  // 取消按钮点击事件->关闭modal

  handleCancelModal = () => {
    this.props.onCancel();
  };

  // 单选框值发生改变时
  radioOnChange = (e) => {
    console.log(e.target.value);
    const value = e.target.value;
    // this.props.setModalWidth(value);
    this.setState({ splx: value });
  };

  //附件onChange-->视频和图片封面要用的公共函数
  fjOnChange = (listMap) => {
    if (listMap && listMap.length > 0) {
      return listMap[0].uuid;
    }
  };
  //处理点击上传视频
  handleSpChange = (spfjid, list, listMap) => {
    console.log(spfjid, list, listMap);

    let res = this.fjOnChange(listMap);
    this.setState({
      spdz: res,
      spfjid,
    });
  };
  //处理点击添加视频封面
  handleSltChange = (sltfjid, list, listMap) => {
    console.log(sltfjid, list, listMap);

    let res = this.fjOnChange(listMap);
    this.setState({
      slt: res,
      sltfjid,
    });
  };

  render() {
    const { form } = this.props;

    const { getFieldDecorator } = form;

    const layout = { labelCol: { span: 6 }, wrapperCol: { span: 17 } };
    const {
      buttonLoading,
      radioValue,
      spdz,
      spsm,
      spmc,
      spfjid,
      sltfjid,
      slt,
      splx,
      lj,
    } = this.state;
    return (
      <div>
        <Form
          layout="vertical"
          hideRequiredMark={true}
          onSubmit={this.handleSubmit}
        >
          <div style={{ margin: "10px 0" }}>
            <b>视频类型</b>
          </div>
          <NHFormItem
            id={"splx"}
            form={form}
            formItemLayout={layout}
            initialValue={splx}
          >
            <Radio.Group onChange={this.radioOnChange} value={splx}>
              <Radio value={"1"}>外部链接</Radio>
              <Radio value={"2"}>本地上传</Radio>
            </Radio.Group>
          </NHFormItem>
          {/* 根据单选框选择的值渲染 */}
          {
            // type=1 展示输入外链url
            splx === "1" ? (
              //
              <div>
                <div style={{ margin: "10px 0" }}>
                  <b>请输入链接</b>
                </div>
                <NHFormItem
                  id={"lj"}
                  form={form}
                  formItemLayout={layout}
                  initialValue={lj}
                >
                  <Input
                    placeholder="请输入"
                    maxLength={400}
                    style={{ width: "377px" }}
                    onChange={(e) => {
                      this.setState({ spdz: e.target.value });
                    }}
                  />
                </NHFormItem>
              </div>
            ) : (
              // 本地上传视频
              <div>
                <div style={{ marginBottom: 10 }}>
                  <span className={styles.labelStyle}>添加视频</span>
                </div>

                <NHFormItem
                  id="spfjid"
                  formItemLayout={layout}
                  form={form}
                  initialValue={spfjid ? spfjid : ""}
                >
                  <NHUpload
                    uploadType={"file"}
                    serviceMark={"sm-comprehensive-evaluation"}
                    moduleName={"学生自评_新增/编辑勾选项"}
                    multiple={false}
                    maxFileSize={500}
                    listType={"picture"}
                    onChange={this.handleSpChange}
                    // image={true}
                    fileTypeLimit={['mp4','ogg']}
                  />
                </NHFormItem>
              </div>
            )
          }
          <div style={{ marginBottom: 10 }}>
            <span className={styles.labelStyle}>添加封面图</span>
          </div>

          <NHFormItem
            id="sltfjid"
            formItemLayout={layout}
            form={form}
            initialValue={sltfjid ? sltfjid : ""}
          >
            <NHUpload
              uploadType={"file"}
              serviceMark={"sm-comprehensive-evaluation"}
              moduleName={"学生自评_新增/编辑勾选项"}
              multiple={false}
              maxFileSize={20}
              listType={"picture-card"}
              onChange={this.handleSltChange}
              image={true}
            />
          </NHFormItem>
          <div style={{ marginBottom: 10 }}>
            <span className={styles.labelStyle}>视频标题(选填)</span>
          </div>
          <NHFormItem
            id={"spmc"}
            form={form}
            formItemLayout={layout}
            initialValue={spmc}
          >
            <Input
              placeholder="请输入"
              maxLength={30}
              style={{ width: "377px" }}
              // onChange={(e) => {
              //   console.log("spsm", e.target.value);
              //   this.setState({ spsm: e.target.value });
              // }}
            />
          </NHFormItem>
          <div style={{ marginBottom: 10 }}>
            <span className={styles.labelStyle}>视频说明(选填)</span>
          </div>
          <NHFormItem
            id={"spsm"}
            form={form}
            formItemLayout={layout}
            initialValue={spsm}
          >
            <Input
              placeholder="请输入"
              maxLength={30}
              style={{ width: "377px" }}
              // onChange={(e) => {
              //   console.log("spsm", e.target.value);
              //   this.setState({ spsm: e.target.value });
              // }}
            />
          </NHFormItem>
          <div>
            <Button
              type="primary"
              htmlType="submit"
              loading={buttonLoading}
              style={{ display: "inline-block", marginRight: "10px" }}
            >
              确定
            </Button>
            <Button loading={buttonLoading} onClick={this.handleCancelModal}>
              取消
            </Button>
          </div>
        </Form>
           
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/fwwgl/spgl/VideoModal.js